import { render, staticRenderFns } from "./ReviewsCategoriesHeatmapStateContainer.vue?vue&type=template&id=127abd5a&scoped=true&"
import script from "./ReviewsCategoriesHeatmapStateContainer.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeatmapStateContainer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeatmapStateContainer.vue?vue&type=style&index=0&id=127abd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127abd5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
